"use client";

import { useState, useRef, useEffect } from "react";
import { X } from "lucide-react";

export function TagSelectInput({ label, value, onChange, options }: any) {
  const [input, setInput] = useState("");
  const [showList, setShowList] = useState(false);

  const wrapperRef = useRef<HTMLDivElement>(null);

  // close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target as Node)) {
        setShowList(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const filtered = (options ?? []).filter(
    (item: any) =>
      item.name.toLowerCase().includes(input.toLowerCase()) &&
      !(value ?? []).includes(item.id)
  );

  const addTag = (tag: any) => {
    onChange([...(value ?? []), tag.id]);
    setInput("");
    setShowList(false);
  };

  const removeTag = (id: number) => onChange((value ?? []).filter((t: number) => t !== id));

  const handleKeyDown = (e: any) => {
    if (e.key === "Enter") {
      e.preventDefault();
      setShowList(true);
    }
  };

  return (
    <div className="relative" ref={wrapperRef}>
      {label && <label className="text-sm font-medium">{label}</label>}

      <div
        className="flex flex-wrap items-center gap-2 p-2 border rounded-lg mt-1 cursor-text"
        onClick={() => setShowList(true)}
      >
        {(value ?? []).map((id: number) => {
          const item = options.find((o: any) => o.id === id);
          return (
            <span key={id} className="bg-gray-100 rounded-full px-3 py-1 flex items-center gap-2 text-sm">
              {item?.name}
              <X size={14} className="cursor-pointer" onClick={() => removeTag(id)} />
            </span>
          );
        })}

        <input
          className="flex-1 outline-none text-sm p-1"
          placeholder="Insert text here..."
          value={input}
          onChange={(e) => {
            setInput(e.target.value);
            setShowList(true);
          }}
          onKeyDown={handleKeyDown}
        />
      </div>

      {showList && (
        <div className="relative z-40 mt-1 w-full bg-white border rounded-lg max-h-60 overflow-y-auto shadow-md">
          {filtered.length === 0 ? (
            <div className="p-3 text-gray-500 text-sm">No match found</div>
          ) : (
            filtered.map((item: any) => (
              <div
                key={item.id}
                className="p-3 hover:bg-gray-100 cursor-pointer text-sm"
                onClick={() => addTag(item)}
              >
                {item.name}
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
}
